import React, {useContext, useEffect, useMemo, useState} from 'react'
import { AuthContext } from '../context/AuthContext'
import api from '../services/api'
import dayjs from 'dayjs'
import IWeaponGuides from "../interfaces/IWeaponGuides";
import IWeapons from "../interfaces/IWeapons";

export function DigitalWallet(): React.JSX.Element {
  const { authUser } = useContext(AuthContext)
  const [armas, setArmas] = useState<any[]>([])

  useEffect(() => {
    if (authUser?.id) {
      api.post(`/api/weapons/my/${authUser?.athlete?.id}`, { active: true }).then((res) => {
        setArmas(res.data)
      })
    }
  }, [authUser])

    const { totalPending, totalDocuments } = useMemo(() => {
        const crPending:1|0 =
            authUser?.athlete?.cr_status !== 'UP_TO_DATE' ? 1 : 0

        const crTotal:1|0 = authUser?.athlete?.cr_number ? 1 : 0

        let weaponsPending = 0
        let weaponsTotal = 0

        armas?.forEach((arma: IWeapons) => {
            weaponsTotal++

            if (arma.craf_status !== 'UP_TO_DATE') {
                weaponsPending++
            }

            weaponsTotal += arma.weapon_guides?.length ?? 0

            weaponsPending +=
                arma.weapon_guides?.filter(
                    (guide: IWeaponGuides) => guide.guide_status !== 'UP_TO_DATE'
                ).length ?? 0
        })

        return {
            totalPending: crPending + weaponsPending,
            totalDocuments: crTotal + weaponsTotal,
        }
    }, [authUser?.athlete?.cr_status, armas])

  return (
    <div>

      <div
          className="card border-0 rounded-4 text-white position-relative overflow-hidden shadow-sm transition-all"
          style={{
            background: 'linear-gradient(135deg, #4a5d51 0%, #35443b 60%, #526b5d 100%)',
            minHeight: '234px',
            cursor: 'pointer'
          }}
          data-bs-toggle="modal"
          data-bs-target="#modalCrafDigital"
          role="button" // Boa prática de acessibilidade
          tabIndex={0}
      >

        {/* Detalhe estético: Marca-d'água do documento */}
        <div
            className="position-absolute"
            style={{
              right: '-10px',
              bottom: '-30px',
              fontSize: '160px',
              lineHeight: '1',
              pointerEvents: 'none',
              transform: 'rotate(-15deg)',
              color: 'rgba(255, 255, 255, 0.06)'
            }}
        >
          <i className="bi bi-file-earmark-text"></i>
        </div>

        <div className="card-body p-4 d-flex flex-column justify-content-between h-100 position-relative z-1">
          <div className="d-flex align-items-start justify-content-between">
            <div>
              <span
                  className="badge bg-black bg-opacity-20 px-2 py-1 rounded-pill mb-2 fw-bold"
                  style={{ fontSize: '10px', letterSpacing: '0.5px', color: '#a3ffc7' }}
              >
              <i className="bi bi-shield-lock-fill me-1"></i> ACERVO DIGITAL
            </span>
              <h5 className="card-title fw-bold m-0 pb-0" style={{ fontSize: '17px', letterSpacing: '0.3px', color: 'rgba(255,255,255,0.75)' }}>
                CARTEIRA DE ATIRADOR
              </h5>
              {/*<h4 className="fw-extrabold text-white mt-1 mb-0" style={{ fontSize: '19px' }}>*/}
              {/*  Carteira de Atirador*/}
              {/*</h4>*/}
            </div>

            <div
                className="bg-black bg-opacity-20 border border-white border-opacity-10 rounded-3 p-2 d-flex align-items-center justify-content-center"
                style={{ width: '42px', height: '42px', color: '#a3ffc7' }}
            >
              <i className="bi bi-person-vcard-fill fs-4"></i>
            </div>
          </div>

          <div className=" pt-2">
            <div className="d-flex align-items-end justify-content-between">

              <div>
                <div className="small font-monospace" style={{ fontSize: '11px', color: 'rgba(255,255,255,0.7)' }}>DOCUMENTOS ATIVOS</div>
                <div className="d-flex align-items-baseline">
                  <span className="display-6 fw-bold text-white lh-1">{totalDocuments}</span>
                  <span className="small ms-2 fw-bold font-monospace" style={{ color: '#a3ffc7' }}>CR / CRAFs / Guias</span>
                </div>
              </div>

              <div
                  className="rounded-circle d-flex align-items-center justify-content-center text-white"
                  style={{ width: '36px', height: '36px', background: 'rgba(255,255,255,0.15)' }}
              >
                <i className="bi bi-eye-fill fs-5"></i>
              </div>
            </div>

              {(totalPending > 0) &&
                <div
                    className="mt-3 p-2 rounded-3 d-flex align-items-center gap-2"
                    style={{ backgroundColor: 'rgba(255, 235, 150, 0.15)', border: '1px solid rgba(255, 235, 150, 0.25)' }}
                >
                      <i className="bi bi-exclamation-triangle-fill text-warning small" style={{ color: '#ffd166' }}></i>
                      <span className="small fw-bold" style={{ fontSize: '12px', color: '#ffe194' }}>
                      {totalPending} documento{totalPending > 1 ?'s ': ''} vence/vencido em breve
                    </span>
                </div>
              }
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalCrafDigital"
        tabIndex={-1}
        aria-labelledby="modalCrafDigitalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-wallet">
          <div className="modal-content bg-light">
            <div className="modal-header border-0 bg-transparent px-3 py-2 position-absolute w-100" style={{ zIndex: 10 }}>
              <span className="text-muted" style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                Carteira Digital do Sócio
              </span>
              <button
                type="button"
                className="btn btn-dark btn-sm rounded-circle d-flex align-items-center justify-content-center p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ width: '28px', height: '28px' }}
              >
                <i className="bi bi-x-lg" style={{ fontSize: '13px' }}></i>
              </button>
            </div>

            <div className="modal-body p-0 bg-secondary bg-opacity-10">
              <div
                id="carrosselCraf"
                className="carousel carousel-dark slide px-2 py-5 px-sm-5"
                data-bs-ride="false"
              >
                <div className="carousel-indicators" style={{ bottom: '-8px' }}>
                  {/* CR */}
                  <button
                    type="button"
                    data-bs-target="#carrosselCraf"
                    data-bs-slide-to={0}
                    className="active"
                    aria-current="true"
                    aria-label="CR"
                    style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#198754' }}
                  />
                  {/* CRAFs */}
                  {armas.map((_: any, index: number) => (
                    <button
                      key={index}
                      type="button"
                      data-bs-target="#carrosselCraf"
                      data-bs-slide-to={index + 1}
                      aria-label={`CRAF ${index + 1}`}
                      style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#198754' }}
                    />
                  ))}
                </div>

                <div className="carousel-inner">
                  {/* CR - sempre o primeiro slide */}
                  <div className="carousel-item active">
                    <div
                        className="bg-white rounded shadow border border-secondary border-opacity-50 p-3 p-sm-4 position-relative d-flex flex-column justify-content-between mx-auto"
                        style={{
                          width: '100%',
                          maxWidth: '520px',
                          minHeight: '320px',
                          aspectRatio: '1.6 / 1',
                          fontSize: 'calc(10px + 0.3vw)',
                        }}
                    >
                      <div
                          className="position-absolute top-50 start-50 translate-middle w-50 h-50 opacity-25"
                          style={{
                            backgroundImage: `url('/Coat_of_arms_of_Brazil.svg')`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            backgroundSize: 'contain',
                            zIndex: 0,
                          }}
                      />
                      <div className="text-center border-bottom border-success pb-2 position-relative" style={{ zIndex: 1 }}>
                        <h6 className="fw-bold text-success text-uppercase mb-0" style={{ fontSize: '1.12em' }}>República Federativa do Brasil</h6>
                        <small className="text-muted d-block fw-semibold" style={{ fontSize: '0.7em' }}>MINISTÉRIO DA DEFESA - EXÉRCITO BRASILEIRO</small>
                        <small className="fw-bold text-dark d-block mt-1" style={{ fontSize: '0.8em' }}>CERTIFICADO DE REGISTRO - CR</small>
                      </div>
                      <div className="row g-3 mt-1 position-relative" style={{ zIndex: 1, fontSize: '0.90em' }}>
                        <div className="col-6">
                          <span className="d-block text-muted fw-bold text-uppercase" style={{ fontSize: '0.75em' }}>NOME</span>
                          <span className="fw-bold text-dark text-uppercase">{authUser?.athlete?.full_name || '-'}</span>
                        </div>
                        <div className="col-6">
                          <span className="d-block text-muted fw-bold text-uppercase" style={{ fontSize: '0.75em' }}>Nº DO CR</span>
                          <span className="font-monospace fw-bold text-dark">{authUser?.athlete?.cr_number || '-'}</span>
                        </div>
                        <div className="col-6 border-top pt-2">
                          <span className="d-block text-muted fw-bold text-uppercase" style={{ fontSize: '0.75em' }}>CPF</span>
                          <span className="font-monospace fw-bold text-dark">{authUser?.athlete?.cpf || '-'}</span>
                        </div>
                        <div className="col-6 border-top pt-2">
                          <span className="d-block text-muted fw-bold text-uppercase" style={{ fontSize: '0.75em' }}>VALIDADE CR</span>
                          <span className={`fw-bold text-uppercase ${authUser?.athlete?.cr_status === "EXPIRED" ? 'text-danger' : 'text-dark'}`}>
                            {authUser?.athlete?.cr_validity_date
                                ? dayjs(authUser.athlete.cr_validity_date).format('DD/MM/YYYY')
                                : '-'}
                          </span>
                        </div>
                      </div>
                      <div
                          className="bg-warning text-black text-center py-1 rounded fw-bold text-uppercase mt-2 position-relative"
                          style={{ fontSize: '0.75em', zIndex: 1 }}
                      >
                        VÁLIDO APENAS PARA CONSULTA. NÃO SUBSTITUI O DOCUMENTO ORIGINAL.
                      </div>
                    </div>
                  </div>
                  {armas.map((arma: any, index: number) => (
                      <div className="carousel-item" key={arma.id}>
                      <div
                        className="bg-white rounded shadow border border-secondary border-opacity-50 p-3 p-sm-4 position-relative d-flex flex-column justify-content-between mx-auto"
                        style={{
                          width: '100%',
                          maxWidth: '520px',
                          minHeight: '320px',
                          aspectRatio: '1.6 / 1',
                          fontSize: 'calc(10px + 0.3vw)',
                        }}
                      >
                        <div
                          className="position-absolute top-50 start-50 translate-middle w-50 h-50 opacity-25"
                          style={{
                            backgroundImage: `url('/Coat_of_arms_of_Brazil.svg')`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            backgroundSize: 'contain',
                            zIndex: 0,
                          }}
                        />

                        <div
                          className="text-center border-bottom border-success pb-2 position-relative"
                          style={{ zIndex: 1 }}
                        >
                          <h6
                            className="fw-bold text-success text-uppercase mb-0"
                            style={{ fontSize: '1.12em' }}
                          >
                            República Federativa do Brasil
                          </h6>
                          <small
                            className="text-muted d-block fw-semibold"
                            style={{ fontSize: '0.7em' }}
                          >
                            MINISTÉRIO DA JUSTIÇA - POLÍCIA FEDERAL
                          </small>
                          <small
                            className="fw-bold text-dark d-block mt-1"
                            style={{ fontSize: '0.8em' }}
                          >
                            CERTIFICADO DE REGISTRO DE ARMA DE FOGO
                          </small>
                        </div>

                        <div
                          className="row g-3 mt-1 position-relative"
                          style={{ zIndex: 1, fontSize: '0.90em' }}
                        >
                          <div className="col-6">
                            <span
                              className="d-block text-muted fw-bold text-uppercase"
                              style={{ fontSize: '0.75em' }}
                            >
                              Nº REGISTRO (SIGMA)
                            </span>
                            <span className="font-monospace fw-bold text-dark">
                              {arma.sigma_number || '-'}
                            </span>
                          </div>
                          <div className="col-6">
                            <span
                              className="d-block text-muted fw-bold text-uppercase"
                              style={{ fontSize: '0.75em' }}
                            >
                              Nº DE SERIE
                            </span>
                            <span className="font-monospace fw-bold text-dark">
                              {arma.serial_number || '-'}
                            </span>
                          </div>

                          <div className="col-6 border-top pt-2">
                            <span
                              className="d-block text-muted fw-bold text-uppercase"
                              style={{ fontSize: '0.75em' }}
                            >
                              ARMA / CALIBRE
                            </span>
                            <span className="text-dark fw-bold text-uppercase">
                              {arma.description} {arma.caliber?.description}
                            </span>
                          </div>
                          <div className="col-6 border-top pt-2">
                            <span
                              className="d-block text-muted fw-bold text-uppercase"
                              style={{ fontSize: '0.75em' }}
                            >
                              VALIDADE CRAF
                            </span>
                            <span className={`fw-bold text-uppercase ${arma?.craf_status === "EXPIRED" ? 'text-danger' : 'text-dark'}`}>
                              {arma.craf_validity
                                ? dayjs(arma.craf_validity).format('DD/MM/YYYY')
                                : '-'}
                            </span>
                          </div>
                        </div>

                        <div
                          className="border-top pt-2 mt-2 position-relative"
                          style={{ zIndex: 1 }}
                        >
                          <span
                            className="d-block text-success fw-bold text-uppercase mb-1"
                            style={{ fontSize: '0.75em', letterSpacing: '0.3px' }}
                          >
                            Guias de Trânsito Ativas
                          </span>
                          <div className="row g-2">
                            {arma.weapon_guides?.map((guia: any) => (
                              <div className="col-6" key={guia.id}>
                                <div className="bg-light border rounded p-1 d-flex justify-content-between align-items-center">
                                  <span className="fw-bold text-dark" style={{ fontSize: '0.85em' }}>
                                    Treino
                                  </span>
                                  <span
                                    className={` font-monospace ${['EXPIRING_SOON', 'EXPIRED'].includes(guia.guide_status) ? `${guia.guide_status === 'EXPIRING_SOON' ? 'text-warning': 'text-danger'} fw-bold text-uppercase` : 'text-muted'}`}
                                    style={{ fontSize: '0.8em' }}
                                  >
                                    Val:{' '}
                                    {guia.guide_validity
                                      ? dayjs(guia.guide_validity).format('DD/MM/YYYY')
                                      : '-'}
                                  </span>
                                </div>
                              </div>
                            ))}
                            {(!arma.weapon_guides || arma.weapon_guides.length === 0) && (
                              <div
                                className="col-12 text-muted fst-italic"
                                style={{ fontSize: '0.8em' }}
                              >
                                Nenhuma guia vinculada.
                              </div>
                            )}
                          </div>
                        </div>

                        <div
                          className="bg-warning text-black text-center py-1 rounded fw-bold text-uppercase mt-2 position-relative"
                          style={{ fontSize: '0.75em', zIndex: 1 }}
                        >
                          VÁLIDO APENAS PARA CONSULTA. NÃO SUBSTITUI O DOCUMENTO ORIGINAL.
                        </div>
                      </div>
                    </div>
                  ))}

                  {armas.length === 0 && (
                    <div className="carousel-item active">
                      <div className="text-center text-muted py-5">Nenhuma arma registrada.</div>
                    </div>
                  )}
                </div>

                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#carrosselCraf"
                  data-bs-slide="prev"
                  style={{ width: '12%' }}
                >
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Anterior</span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#carrosselCraf"
                  data-bs-slide="next"
                  style={{ width: '12%' }}
                >
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Próximo</span>
                </button>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  )
}
